module.exports = __webpack_public_path__ + "img/fam.af528dfe.webp";